/**
 * @file: useChangeOrderFlowStep.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { useOrderFlowContext } from '@euler/app/flows/order/OrderFlowContext';
import { OrderFlowStep } from '@euler/app/flows/order/types';
import { useFocusEffect } from '@react-navigation/native';

export const useChangeOrderFlowStep = (step: OrderFlowStep) => {
  const { step$ } = useOrderFlowContext();
  useFocusEffect(() => {
    step$.next(step);
  });
};
